/**
 * X12 service type codes (STC) offered in the eligibility form / explorer.
 * Lifted out of the retired mockData module — these are real EDI constants,
 * not demo fixtures.
 */

import type { ServiceType } from '../types'

export const SERVICE_TYPES: ServiceType[] = [
  { code: '30', label: 'Health Benefit Plan Coverage' },
  { code: '33', label: 'Chiropractic' },
  { code: '47', label: 'Hospital' },
  { code: '86', label: 'Emergency Services' },
  { code: '88', label: 'Pharmacy' },
  { code: '96', label: 'Professional (Physician) Visit - Specialist' },
  { code: '98', label: 'Professional (Physician) Visit - Office' },
  { code: 'AL', label: 'Vision (Optometry)' },
  { code: 'MH', label: 'Mental Health' },
]
